//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['event', 'statsURL'],
  data() {
    return {
      tab: 'preview',
    }
  },
  computed: {
    stats() {
      return _.get(this.event, 'stats')
    }
  },
  mounted() {},
  methods: {
    openLiveStats() {
      if(this.tab != 'live') {
        this.tab = 'live'
      } else {
        this.tab = 'preview'
      }
    },
    openStats() {
      this.$store.commit('setStatId', this.event.id)
      this.$modal.show('modal-stats')
    }
  }
}
